import { render, staticRenderFns } from "./ComplementModal.vue?vue&type=template&id=1adb1528&scoped=true"
import script from "./ComplementModal.vue?vue&type=script&lang=js"
export * from "./ComplementModal.vue?vue&type=script&lang=js"
import style0 from "./ComplementModal.vue?vue&type=style&index=0&id=1adb1528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adb1528",
  null
  
)

export default component.exports